import type { ThemeMode, ThemeName } from "./theme.js";
import { resolveTheme } from "./theme.js";

export type { ThemeMode, ThemeName };

const STORAGE_KEY = "ead-expui.theme.v1";

export type ThemeSettings = { theme: ThemeName; themeMode: ThemeMode };

export function loadThemeSettings(): ThemeSettings {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { theme: "claw", themeMode: "system" };
    const s = JSON.parse(raw) as Record<string, unknown>;
    const theme = s.theme;
    const themeMode = s.themeMode;
    return {
      theme: theme === "claw" || theme === "knot" || theme === "dash" ? theme : "claw",
      themeMode:
        themeMode === "system" || themeMode === "light" || themeMode === "dark"
          ? themeMode
          : "system",
    };
  } catch {
    return { theme: "claw", themeMode: "system" };
  }
}

export function saveThemeSettings(settings: ThemeSettings): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
  } catch {
    /* ignore */
  }
}

export function applyThemeToDocument(theme: ThemeName, themeMode: ThemeMode): void {
  if (typeof document === "undefined") return;
  const resolved = resolveTheme(theme, themeMode);
  document.documentElement.setAttribute("data-theme", resolved);
  const mode: "light" | "dark" =
    resolved === "light" || resolved.endsWith("-light") ? "light" : "dark";
  document.documentElement.setAttribute("data-theme-mode", mode);
}
